// extracted by mini-css-extract-plugin
export default {"ResetFormError":"PasswordResetForm_ResetFormError__Bx7yX"};